<p-columnFilter [field]="columnName" [showButtons]="false" [showMenu]="false">
  <ng-template
    class="prospects-panel d-flex justify-content-between ms-2 me-auto"
    pTemplate="filter"
    let-value
    let-filter="filterCallback">
    <div class="p-d-flex p-flex-column p-ai-center">
      <div
        class="filter-toggle text-center"
        (click)="showFilterDialog = !showFilterDialog">
        <i class="pi pi-filter"></i>
      </div>
      <p-dialog
        header="Select Filter Criteria"
        [position]="'center'"
        [resizable]="false"
        [draggable]="false"
        [(visible)]="showFilterDialog"
        [style]="{
          width: '300px',
          height: '350px',
          'border-radius': '10px',
          overflow: 'visible',
        }">
        <div class="p-fluid p-dir-col p-p-3">
          <div class="row">
            <div class="col-12">
              <label
                class="text-bold matchMode form-group has-float-label mb-1"
                for="dateFilter.selectedMatchMode"
                >Match Mode</label
              >
            </div>
            <div class="col-12">
              <p-select
                [options]="matchModeOptions"
                [(ngModel)]="dateFilter.selectedMatchMode"
                optionLabel="label"
                optionValue="value"
                placeholder="Select Match Mode"
                [required]="true"></p-select>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-12">
              <label
                class="text-bold form-group has-float-label"
                for="dateFilter.startDate"
                >{{
                  dateFilter.selectedMatchMode !== "between"
                    ? "Date"
                    : "Start Date"
                }}
              </label>
            </div>
            <div class="col-12">
              <p-date-picker
                [(ngModel)]="dateFilter.startDate"
                [showButtonBar]="true"
                [inputStyle]="{ height: '30px' }"
                [style]="{ width: '100%' }"
                [appendTo]="'body'"
                dateFormat="mm-dd-yy"></p-date-picker>
            </div>
          </div>

          <div
            class="row mt-2"
            *ngIf="dateFilter.selectedMatchMode === 'between'">
            <div class="col-12">
              <label
                class="text-bold form-label form-group has-float-label"
                for="dateFilter.endDate"
                >End Date
              </label>
              <div class="col-12">
                <p-date-picker
                  [(ngModel)]="dateFilter.endDate"
                  [showButtonBar]="true"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                  dateFormat="mm-dd-yy"></p-date-picker>
              </div>
            </div>
          </div>
          <div
            class="d-flex py-3 has-sticky justify-content-end p-0 gap-2 align-items-center">
            <p-button
              label="Clear"
              type="button"
              (click)="clearFilter()"
              severity="secondary" />

            <p-button
              label="Apply"
              type="button"
              [disabled]="dateFilter.startDate === ''"
              type="submit"
              (click)="applyFilter()" />
          </div>
        </div>
      </p-dialog>
    </div>
  </ng-template>
</p-columnFilter>
